import { onDropdownClose } from '../helpers/selectize_helpers';
import { setSelectizeFieldsCSS } from './subscriptions/helpers';

const REGEX_EMAIL =
  "([a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@" +
  '(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)';

const NPI_STATES = {
  AL: '792cb3da-b81d-4b84-9fe2-5eb2e8ba2fe1',
  AK: '9761b2a2-64e3-44b7-ade7-8048a005b464',
  AZ: '5a2065a2-ff3c-44a9-9700-27478430ca5a',
  AR: '79a51f67-061b-4ab8-bf0e-89803c848190',
  CA: 'f8304174-c9d1-426d-9fe8-ed8b8ccc111b',
  CO: 'f8a476d8-f08c-4edf-a899-17ed68012611',
  CT: '7bacf4b6-0333-4079-81b3-4a132e533cac',
  DE: '3020b27e-e1ee-4e00-8ddc-632c15e174b0',
  FL: '31aab059-4059-468e-8093-3d43ddf784f6',
  GA: '35c4d00d-12c4-454d-b07c-0ae6fa3cf07e',
  HI: '20b70c99-1e4d-4c31-b080-2eee352b25d4',
  ID: '7dc74aa6-7dba-41e4-81e4-00e70dc276f2',
  IL: 'e9520da2-4db6-4394-9267-42d36ac9d414',
  IN: '5fffbfda-9a70-41ce-adef-6744af74bd33',
  IA: '9ca6d9ee-f97c-4ae4-87c7-8c48406338ab',
  KS: '86439c19-917e-43fa-820c-ca275e10ab91',
  KY: 'b3724b8d-2661-4d7b-9cba-efb79b13a3c5',
  LA: '4d1e896f-ffbd-4e58-ae27-04e9a61b98e9',
  ME: '22a7dc8e-b87d-4992-b6c7-4cd4f3fe351f',
  MD: 'da24b130-4488-4c33-a6e4-c7f1eecec046',
  MA: 'edd0adb7-cbce-486d-bff7-b9022b784ca0',
  MI: 'aeda968a-ddbb-402a-9553-6f7625b78d60',
  MN: 'df15f16d-0c20-45ae-b9ba-61caa5793599',
  MS: 'dd164fcb-7e1f-4f60-ad09-a82cff9c8c83',
  MO: '74926e67-b6e0-4bf6-936f-fbfb901a3628',
  MT: 'cb15ecc7-e6bc-4cec-abce-ed9c67f20132',
  NE: 'fada5e0c-d1fc-4903-b692-656e1ff67e90',
  NV: 'b2084b65-cf73-4dd6-aff0-9c3e04af758c',
  NH: '8ea0d008-37b7-4f0a-ac0e-f9fd9dbc4e9b',
  NJ: 'f59d589f-1a76-43c6-b5cb-33e1b633c666',
  NM: 'fd639e11-14f2-4596-b771-ade4fe42641f',
  NY: 'cc87d550-2fff-4eb4-ada0-1ee7928f7ce9',
  NC: 'bb8e1276-f348-48bb-af1d-19e670289706',
  ND: '75e3b344-c84a-4087-ae05-15556b5188ba',
  OH: 'c97f229b-5ea2-4e72-94a0-b747863ed408',
  OK: '336758ff-ad13-41a4-80c2-7b812e6e34af',
  OR: 'f42355d8-1282-4241-b063-5d77ebe2d682',
  PA: '9e4547c7-be31-4ebe-8471-75647fa2e1cd',
  RI: '07cedcb1-71a3-4653-9f88-03e5f4e34632',
  SC: 'ada5b0f2-4e86-4b28-8a03-b4d954fe40f2',
  SD: '62e2edb0-5b96-41b8-a75f-5294c9fde059',
  TN: '3e9e112c-3954-4001-b180-aac3a71a334c',
  TX: '45c2200c-3d40-4d59-886d-69f95863bb93',
  UT: '693d1508-dea8-4227-b168-0f343390bb5a',
  VT: 'e4aba46b-6bf3-498f-b9fc-4d0156b3630a',
  VA: 'cd92b344-01ce-44ed-b27d-dc9b2dc53387',
  WA: '8417da33-6057-4607-8770-d3dc46acfd62',
  WV: 'a188df66-9d72-492e-a5d3-61af7c3b7b03',
  WI: '1a9a1b72-229f-433d-8ae1-c0aae33845b2',
  WY: '24792adb-2104-470e-b007-89941e449edc',
  DC: '2d568ff0-0456-48c8-9ff4-c04fb8836185',
  PR: '80ceb63b-928d-4112-9e12-67f9388c17f4',
  AS: 'f4a3b53d-dd70-41d3-96f8-5fb4f269c492',
  GU: '17297d90-6e71-437b-ad5c-7cdeb6fa0d59',
  VI: 'c09bb695-c2f2-4db7-b4b1-273eba209e5b',
  FM: '5da2e734-c0b8-4858-b6dc-3a5b6508c8a1',
  MH: '600bd931-29e6-4274-b356-c230390a49a3',
  MP: 'c6e554e0-4697-4e0e-8151-3c428456605c',
  PW: '828066ee-7ae4-4176-9087-2e752434998f',
};

const NPI_ADDRESS_TYPES = {
  'LOCATION AND MAILING': 'f6749b20-b2e5-4992-bf11-6e5585b5df70',
  LOCATION: '319705a9-f58e-4da2-9dd7-dacdfb7a1e42',
  MAILING: 'ea876400-61b4-4bb9-a37e-b6a2171d88ab',
};

const NPI_PHONE_NUMBER_TYPES = {
  telephone_number: '80e9a6e6-14b5-4bff-9b48-bad20308eef6',
  fax_number: '31053637-ac84-4f96-8844-3bc829f3a251',
};

// NPI address fields and the form attribute names they map to
const NPI_ADDRESS_FIELD_MAP = {
  address_1: 'address',
  address_2: 'address_2',
  address_purpose: 'address_type_id',
  address_type: '',
  city: 'city',
  country_code: 'country_code',
  country_name: 'country_name',
  fax_number: 'fax_number',
  postal_code: 'zip_code',
  state: 'state_id',
  telephone_number: 'telephone_number',
};

// Provider attribute fields that are copied from NPI search results to the form
const NPI_PROVIDER_FIELDS = [
  'first_name',
  'last_name',
  'middle_name',
  'organization_name',
  'suffix',
  'active',
  'primary_taxonomy_name',
  'primary_taxonomy_number',
];

function preservePlaceholder(selectizeInstance) {
  const placeholder = selectizeInstance.$input[0].getAttribute('placeholder');
  if (placeholder) {
    selectizeInstance.$control_input[0].placeholder = placeholder;
  }
}

// Builds a config for a basic "type to search a remote API" Selectize. Single-select, no preload.
function asyncSearchConfig({ url, labelField = 'name', placeholder, ...overrides }) {
  return {
    valueField: 'id',
    labelField,
    searchField: labelField,
    placeholder,
    options: [],
    create: false,
    onDropdownClose,
    onInitialize() {
      preservePlaceholder(this);
    },
    load(query, callback) {
      if (!query.length) return callback();
      return $.ajax({
        url,
        type: 'GET',
        dataType: 'json',
        data: { q: query },
        error() {
          callback();
        },
        success(res) {
          callback(res);
        },
      });
    },
    ...overrides,
  };
}

// Builds a config for a single-select that preloads + populates an existing value via dataset.id
function preloadedSingleSelectConfig({ url, labelField = 'name', placeholder, buildLoadData, ...overrides }) {
  return {
    valueField: 'id',
    labelField,
    searchField: labelField,
    maxItems: 1,
    placeholder,
    options: [],
    preload: true,
    create: false,
    onDropdownClose,
    load(query, callback) {
      if (!query) return callback();
      return $.ajax({
        url,
        type: 'GET',
        dataType: 'json',
        data: { q: query },
        error() {
          callback();
        },
        success(res) {
          callback(res);
        },
      });
    },
    onChange(value) {
      const select = this.$input[0];
      const option = select.options[0];
      option.value = value;
      select.value = value;
    },
    onInitialize() {
      preservePlaceholder(this);
      const select = this.$input[0].dataset;
      const data = buildLoadData ? buildLoadData(this.$input[0], select) : { q: select.name };
      $.ajax({
        url,
        type: 'GET',
        dataType: 'json',
        data,
        error() {},
        success: (res) => {
          if (!res) return;
          this.addOption(res);
          this.addItem([select.id]);
        },
      });
    },
    ...overrides,
  };
}

function setProviderAttributes(select, result) {
  const container = select.closest('div');
  NPI_PROVIDER_FIELDS.forEach((field) => {
    if (result[field]) {
      const el = container.querySelector(`.provider_${field}`);
      if (el) el.value = result[field];
    }
  });
}

function setProviderAddressFields(addressAttributeDelineation, result) {
  result.addresses.forEach((address, index) => {
    const workPhoneEl = document.getElementById(
      `${addressAttributeDelineation}_${index}_phone_numbers_attributes_0_number`
    );
    const workPhoneTypeEl = document.getElementById(
      `${addressAttributeDelineation}_${index}_phone_numbers_attributes_0_phone_number_type_id`
    );
    const workFaxEl = document.getElementById(
      `${addressAttributeDelineation}_${index}_phone_numbers_attributes_1_number`
    );
    const workFaxTypeEl = document.getElementById(
      `${addressAttributeDelineation}_${index}_phone_numbers_attributes_1_phone_number_type_id`
    );

    if (workPhoneEl && workPhoneTypeEl && address.telephone_number) {
      workPhoneEl.value = address.telephone_number;
      workPhoneTypeEl.value = NPI_PHONE_NUMBER_TYPES.telephone_number;
    }
    if (workFaxEl && workFaxTypeEl && address.fax_number) {
      workFaxEl.value = address.fax_number;
      workFaxTypeEl.value = NPI_PHONE_NUMBER_TYPES.fax_number;
    }

    Object.entries(NPI_ADDRESS_FIELD_MAP).forEach(([field, mappedField]) => {
      let fieldValue = address[field];
      const id = `${addressAttributeDelineation}_${index}_${mappedField}`;
      const fieldElement = document.getElementById(id);
      if (field === 'address_purpose') {
        fieldValue = NPI_ADDRESS_TYPES[fieldValue];
      } else if (field === 'state') {
        fieldValue = NPI_STATES[fieldValue];
      } else if (field === 'postal_code' && fieldValue && fieldValue.length > 5) {
        fieldValue = `${fieldValue.slice(0, 5)}-${fieldValue.slice(5)}`;
      }
      if (fieldValue && fieldElement) fieldElement.value = fieldValue;
    });
  });
}

function initEmailAndTaggable() {
  $('.taggable-email-input').selectize({
    plugins: ['remove_button'],
    delimiter: ',',
    createOnBlur: true,
    persist: false,
    onDropdownClose,
    createFilter(input) {
      const regex = new RegExp(`^${REGEX_EMAIL}$`, 'i');
      const match = input.match(regex);
      if (match) return !Object.prototype.hasOwnProperty.call(this.options, match[0]);
      return false;
    },
    create(input) {
      if (new RegExp(`^${REGEX_EMAIL}$`, 'i').test(input)) {
        return { value: input, text: input };
      }
      // eslint-disable-next-line no-alert
      alert('Invalid email address.');
      return false;
    },
  });

  $('.taggable').selectize({
    plugins: ['remove_button'],
    delimiter: ',',
    createOnBlur: false,
    persist: false,
  });
}

function initSchoolAndDistrict() {
  $('.select.school-select').selectize(
    preloadedSingleSelectConfig({
      url: '/api/v2/schools',
      placeholder: 'Start typing to search for a school...',
    })
  );

  $('.select.district-select').selectize(
    preloadedSingleSelectConfig({
      url: '/api/v2/districts',
      placeholder: 'Start typing to search for a district...',
      buildLoadData(input, select) {
        const data = { q: select.name };
        if (input.classList.contains('lazy-load')) {
          data.limit_initial = 5;
        }
        return data;
      },
    })
  );
}

function initNpiSelect() {
  $('.select.npi-select').selectize({
    valueField: 'id',
    labelField: 'name',
    searchField: 'name',
    maxItems: 1,
    placeholder: 'Start typing to search for a provider...',
    options: [],
    preload: true,
    create: false,
    onDropdownClose,
    load(query, callback) {
      const select = this.$input[0];
      if (!query) return callback();
      return $.ajax({
        url: '/api/v2/npi-search',
        type: 'GET',
        dataType: 'json',
        data: { q: query },
        error() {
          callback();
        },
        success(res) {
          if (!res || !res[0]) return;
          setProviderAttributes(select, res[0]);
          callback(res);
        },
      });
    },
    onChange(value) {
      const select = this.$input[0];
      $.ajax({
        url: '/api/v2/npi-search',
        type: 'GET',
        dataType: 'json',
        data: { q: value },
        error() {},
        success(res) {
          if (!res || !res[0]) return;
          const result = res[0];

          const addProviderButton = document.getElementById('add-provider-button');
          const providerSpinner = document.getElementById('provider-spinner');
          const addProviderIcon = document.getElementById('add-provider-icon');
          const delineationElement = select.closest('div').querySelector('.addressAttributeDelineation');
          const addressAttributeDelineation = delineationElement && delineationElement.dataset.delineation;

          if (addProviderButton) {
            providerSpinner.classList.remove('d-none');
            addProviderIcon.classList.add('d-none');
            addProviderButton.disabled = true;
          }

          setProviderAttributes(select, result);

          if (addressAttributeDelineation) {
            setProviderAddressFields(addressAttributeDelineation, result);
          }

          if (addProviderButton) {
            // re-enable add provider button with delay to allow parameters all set
            setTimeout(() => {
              addProviderButton.disabled = false;
              providerSpinner.classList.add('d-none');
              addProviderIcon.classList.remove('d-none');
            }, 1500);
          }
        },
      });
    },
    onInitialize() {
      preservePlaceholder(this);
      const select = this.$input[0].dataset;
      $.ajax({
        url: '/api/v2/npi-search',
        type: 'GET',
        dataType: 'json',
        data: { q: select.id },
        error() {},
        success: (res) => {
          if (!res) return;
          this.addOption(res);
          this.addItem([select.id]);
        },
      });
    },
  });
}

function initAsyncSearchSelects() {
  const searches = [
    { selector: '.select.goal-select', url: '/api/v2/goals', labelField: 'goal', placeholder: 'a goal' },
    { selector: '.select.activity-item-select', url: '/api/v2/activity-items', placeholder: 'an item' },
    { selector: '.select.word-select', url: '/api/v2/words', labelField: 'word', placeholder: 'a word' },
    { selector: '.select.word-group-select', url: '/api/v2/word-groups', placeholder: 'a word group' },
    { selector: '.select.minimal-pair-select', url: '/api/v2/minimal-pairs', placeholder: 'a minimal pair' },
    { selector: '.select.lemma-select', url: '/api/v2/lemmas', labelField: 'lemma', placeholder: 'a lemma' },
    { selector: '.select.activity-list-select', url: '/api/v2/activity-lists', placeholder: 'an activity list' },
    { selector: '.select.language-select', url: '/api/v2/languages', placeholder: 'a language' },
    { selector: '.select.resource-select', url: '/api/v2/resources', placeholder: 'a PDF resource' },
  ];

  searches.forEach(({ selector, url, labelField, placeholder }) => {
    $(selector).selectize(
      asyncSearchConfig({
        url,
        labelField,
        placeholder: `Start typing to search for ${placeholder}...`,
      })
    );
  });
}

function initMessagePatientSelect() {
  $('.select.message-patient-select').selectize({
    valueField: 'id',
    labelField: 'name',
    searchField: ['name'],
    placeholder: 'Start typing to search for a patient...',
    options: [],
    create: false,
    plugins: ['remove_button'],
    delimiter: ',',
    persist: false,
    onDropdownClose,
    disabledField: 'disable',
    onInitialize() {
      preservePlaceholder(this);
      this.addOption({ id: -1, name: 'Enter two or more characters', disable: true });
    },
    onLoad() {
      this.removeOption(-1);
    },
    load(query, callback) {
      if (!query.length || query.length < 2) return callback();
      const authToken = document.querySelector('meta[name="api-auth-token"]')?.getAttribute('content');
      const organizationId = this.$input[0].dataset.organizationId;
      return $.ajax({
        url: `/api/v2/patients`,
        type: 'GET',
        headers: { 'X-API-AUTH-TOKEN': `Token token=${authToken}` },
        dataType: 'json',
        data: { q: query, organization_id: organizationId },
        error() {
          callback();
        },
        success(res) {
          callback(res);
        },
      });
    },
  });
}

function initReferenceLinkSelect() {
  const renderItem = (item) => {
    if (item.author !== null && item.author !== undefined) {
      return `<div class="p-1">${item.title} <small>(${item.author})</small></div>`;
    }
    return `<div class="p-1">${item.title}</div>`;
  };

  $('.select.reference-link-select').selectize({
    valueField: 'id',
    labelField: 'title',
    searchField: 'title',
    dataAttr: 'description',
    placeholder: 'Start typing to search for a reference link...',
    options: [],
    create: false,
    onDropdownClose,
    render: { item: renderItem, option: renderItem },
    load(query, callback) {
      if (!query.length) return callback();
      return $.ajax({
        url: '/api/v2/reference-links',
        type: 'GET',
        dataType: 'json',
        data: { q: query },
        error() {
          callback();
        },
        success(res) {
          callback(res);
        },
      });
    },
    onChange(value) {
      const select = this.$input[0];
      const option = select.options[0];
      option.value = value;
      select.value = value;
      const data = this.options[value];
      if (data && data.description) {
        select.closest('div').parentNode.querySelector('.description-field').value = data.description;
      }
    },
    onInitialize() {
      preservePlaceholder(this);
      const select = this.$input[0].dataset;
      $.ajax({
        url: '/api/v2/reference-links',
        type: 'GET',
        dataType: 'json',
        data: { q: select.name },
        error() {},
        success: (res) => {
          if (!res) return;
          this.addOption(res);
          this.addItem([select.id]);
        },
      });
    },
  });
}

function initAddPermissionsSelect() {
  // Used in app/views/organizations_users/_add_permission_modal.html.erb
  $('select.add-permissions').selectize({
    onDropdownClose,
    onChange(value) {
      if (value) {
        $('#grant_permission_btn').removeAttr('disabled');
      }
    },
  });
}

// Customer payment method form: app/views/customer_payment_methods/{new,index}.html.erb.
// The State and Telephone-type selects are selectized by the generic `.select.filterable`
// initializer in application.js (which runs before initSelectize here), so the instances
// already exist. We own their change handlers and the phone <-> phone-type "required"
// coupling here — in the same pack that creates the instances — instead of reaching across
// from the customer pack, which fired in an uncontrolled order.
function initCustomerPaymentForm() {
  const form = document.getElementById('payment-method-form');
  if (!form) return;

  const stateSelect = document.getElementById('state');
  if (stateSelect?.selectize) {
    stateSelect.selectize.on('change', setSelectizeFieldsCSS);
  }

  const phoneInput = document.getElementById('telephone');
  const phoneNumberTypeSelect = document.getElementById('phone_number_type');
  if (!phoneInput || !phoneNumberTypeSelect?.selectize) return;

  const phoneTypeSelectize = phoneNumberTypeSelect.selectize;

  // Phone type is required only while a phone number is present. The select has no static
  // `required` attribute, so selectize caches `isRequired = false` at init and strips the
  // `.required` class from its control on every refreshClasses() (focus/blur/change). A
  // manually-added class therefore survives only until the next interaction — which is why
  // a second submit with the type still missing rendered valid (green) with no message.
  // Drive selectize's own `isRequired` flag instead, so it maintains the class for us and
  // setSelectizeFieldsCSS keeps detecting the field as required.
  const syncPhoneTypeRequired = () => {
    const required = phoneInput.value.length > 0;
    phoneNumberTypeSelect.required = required;
    phoneTypeSelectize.isRequired = required;
    phoneTypeSelectize.refreshClasses();
  };

  // Reverse coupling: choosing a phone type makes the phone number itself required.
  phoneTypeSelectize.on('change', (value) => {
    phoneInput.toggleAttribute('required', value.length > 0);
    setSelectizeFieldsCSS();
  });

  phoneInput.addEventListener('input', () => {
    syncPhoneTypeRequired();
    setSelectizeFieldsCSS();
  });
}

export default function initSelectize() {
  initEmailAndTaggable();
  initSchoolAndDistrict();
  initNpiSelect();
  initAsyncSearchSelects();
  initMessagePatientSelect();
  initReferenceLinkSelect();
  initAddPermissionsSelect();
  initCustomerPaymentForm();
}
